export default __webpack_public_path__ + "static/media/ai-photo-transformation-challenge.95a54a81.png";